import React from 'react';
import { useConfig } from 'context/ConfigContext.js';

const Contact = () => {
  const config = useConfig();

  return (
      <section className="py-16 px-4 bg-white">
        <div id="appIndexContact" className="container mx-auto text-center">
          <h2 className="text-3xl md::text-4xl font-bold mb-8 text-sky-700">
            Questions? Contact Us!
          </h2>
          <p className="text-lg text-gray-700 mb-6 max-w-xl mx-auto">
            If you have any questions, suggestions, or account-related requests, please feel free to contact us via email.
          </p>
          <a
            href={`mailto:${config.emailForSupport.toLowerCase()}`}
            className="text-sky-600 text-xl font-semibold hover:underline"
          >
            {config.emailForSupport.toLowerCase()}
          </a>
        </div>
      </section>
  );
};

export default Contact;